<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPin_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.729 1.7a.7.7 0 0 1 .7-.7h7.143a.7.7 0 1 1 0 1.4H9.966l.684 4.839c.318.167.615.365.885.591C12.473 8.618 13 9.686 13 10.8H8.7v3.5a.7.7 0 1 1-1.4 0v-3.5H3c0-1.114.527-2.182 1.464-2.97a4.96 4.96 0 0 1 .885-.591L6.033 2.4H4.43a.7.7 0 0 1-.7-.7Z"
        clip-rule="evenodd"
    />
</svg>
